module.exports = __webpack_public_path__ + "static/c11-6943d13560e39a9f8911e81f13b66648.jpg";